import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface AppLayoutProps {
  /** Page title rendered in the topbar - always "RFP" in the current design. */
  title?: string;
  children: ReactNode;
}

export function AppLayout({ title = 'RFP', children }: AppLayoutProps) {
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="app-main">
        <Topbar title={title} />
        <main className="app-content">{children}</main>
      </div>
    </div>
  );
}
